export const about = [
  // 1
  `<section id="about1" class="py-5 bg-light text-center">
      <div class="container">
        <h2 class="fw-bold mb-4">Про WhiteEx</h2>
        <p class="mx-auto" style="max-width: 720px;">
          WhiteEx — це платформа, яка створена для структуризації цифрових бізнес-процесів і контролю фінансових потоків. 
          Ми поєднуємо аналітичний підхід із практичними інструментами для підприємств будь-якого масштабу. 
          Наша мета — спростити складні операції та перетворити хаотичні дані на чітку систему. 
          WhiteEx дозволяє власникам бізнесу бачити повну картину діяльності у режимі реального часу. 
          Сервіс постійно оновлюється, забезпечуючи стабільність, безпеку та сучасні рішення.
        </p>
        <a href="about.html" class="btn btn-warning mt-3">Детальніше</a>
      </div>
    </section>`,

  // 2
  `<section id="about2" class="py-5 bg-white">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <img src="https://picsum.photos/seed/about2/700/450" class="img-fluid rounded shadow" alt="WhiteEx Team">
          </div>
          <div class="col-md-6">
            <h2 class="fw-bold mb-3">WhiteEx — сучасна структура даних</h2>
            <p>
              WhiteEx формує інтелектуальний простір для роботи з даними, аналітикою та фінансовими процесами. 
              Ми створюємо інструменти, які забезпечують чіткість і порядок у кожному етапі бізнесу. 
              Система розроблена з урахуванням потреб підприємців, бухгалтерів і консультантів. 
              Усі модулі працюють узгоджено, створюючи логічну екосистему управління. 
              Це не просто інструмент, а метод організації ефективної роботи.
            </p>
            <a href="about.html" class="btn btn-dark mt-3">Детальніше</a>
          </div>
        </div>
      </div>
    </section>`,

  // 3
  `<section id="about3" class="py-5 bg-light">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 order-2 order-md-1">
            <h2 class="fw-bold mb-3">Методичність і прозорість із WhiteEx</h2>
            <p>
              WhiteEx побудовано на принципах точності та документованої прозорості. 
              Кожна дія у системі відслідковується, що забезпечує високий рівень довіри. 
              Ми прагнемо зробити бізнес-процеси не лише ефективними, а й зрозумілими. 
              WhiteEx підтримує інтеграцію з різними інструментами, спрощуючи роботу з даними. 
              Усе це створює екосистему, де кожен елемент має логічне місце.
            </p>
            <a href="about.html" class="btn btn-warning mt-3">Детальніше</a>
          </div>
          <div class="col-md-6 order-1 order-md-2 text-center">
            <img src="https://picsum.photos/seed/about3/700/450" class="img-fluid rounded shadow" alt="WhiteEx Data">
          </div>
        </div>
      </div>
    </section>`,

  // 4
  `<section id="about4" class="py-5 bg-dark text-white">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6">
            <h2 class="fw-bold mb-3 text-warning">WhiteEx — аналітика без хаосу</h2>
            <p>
              У світі, де інформації стає дедалі більше, WhiteEx допомагає побачити головне. 
              Ми створили платформу, яка перетворює числові дані у зрозумілі аналітичні звіти. 
              Кожен бізнес може працювати на основі точних показників і перевірених фактів. 
              Продукт орієнтований на стабільність, безпеку та адаптивність до вимог клієнта. 
              З WhiteEx ви отримуєте не просто цифри, а впорядковану логіку розвитку.
            </p>
            <a href="about.html" class="btn btn-outline-warning mt-3">Детальніше</a>
          </div>
          <div class="col-lg-6 text-center">
            <img src="https://picsum.photos/seed/about4/700/450" class="img-fluid rounded shadow" alt="Analytics WhiteEx">
          </div>
        </div>
      </div>
    </section>`,

  // 5
  `<section id="about5" class="py-5 bg-white text-center">
      <div class="container">
        <h2 class="fw-bold mb-4">WhiteEx — технологія системного мислення</h2>
        <p class="mb-5 mx-auto" style="max-width: 720px;">
          WhiteEx створений для того, щоб компанії могли керувати бізнесом структуровано. 
          Ми забезпечуємо зв’язок між фінансами, аналітикою та документацією. 
          У нашій системі кожен показник має логічне пояснення. 
          Продукт орієнтований на стабільний розвиток і методичну чіткість. 
          Це рішення, що допомагає зрозуміти власну компанію через дані.
        </p>
        <div class="row g-4 justify-content-center">
          <div class="col-6 col-md-4">
            <i class="bi bi-diagram-3 display-5 text-warning"></i>
            <p class="mt-2">Структура</p>
          </div>
          <div class="col-6 col-md-4">
            <i class="bi bi-cpu display-5 text-warning"></i>
            <p class="mt-2">Технології</p>
          </div>
          <div class="col-6 col-md-4">
            <i class="bi bi-lightbulb display-5 text-warning"></i>
            <p class="mt-2">Інтелект</p>
          </div>
        </div>
        <a href="about.html" class="btn btn-warning mt-4">Детальніше</a>
      </div>
    </section>`,

  // 6
  `<section id="about6" class="text-white text-center py-5" style="background:linear-gradient(120deg,#1c1f24,#3b6ea5,#3fb3c3); background-size:400% 400%; animation:gradient 10s ease infinite;">
      <div class="container py-5">
        <h2 class="fw-bold mb-4">WhiteEx — системність у кожному рішенні</h2>
        <p class="mx-auto" style="max-width:720px;">
          Ми створили WhiteEx, щоб бізнес отримав інструмент для аналітики та управління без надмірної складності. 
          Усі модулі інтегровані між собою, створюючи єдину логічну екосистему. 
          Платформа допомагає не лише контролювати, а й розуміти фінансові процеси. 
          Наш підхід базується на структурі, прозорості та точності. 
          WhiteEx — це спосіб зробити бізнес впевненішим у власних рішеннях.
        </p>
        <a href="about.html" class="btn btn-light mt-3">Детальніше</a>
      </div>
    </section>`,
  `<section class="bg-light pb-5 pt-5">
    <div class="container pb-5 pt-5">
        <div class="align-items-center mb-3 row">
            <div class="col-lg-7">
                <h2 class="h6 mb-1 text-primary">Über uns</h2>
                <h3 class="fw-bold h2 mb-1">Bridging Business and Finance</h3>
                <p class="fw-light">Wir bauen Brücken zwischen Unternehmen und Finanzwelt. Durch innovative Strategien, fundierte Analysen und maßgeschneiderte Lösungen helfen wir unseren Kunden, wirtschaftliches Potenzial zu entfalten und nachhaltigen Erfolg zu erzielen.</p>
            </div>
            <div class="col-lg-auto ms-auto"><a href="about.html" class="btn btn-primary">Jetzt mehr erfahren</a>
            </div>
        </div>
        <div class="align-items-center mb-3 row">
            <div class="col-lg-6 order-lg-2">
                <img src="https://images.unsplash.com/photo-1417733403748-83bbc7c05140?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" class="img-fluid" loading="lazy" width="100%">
            </div>
            <div class="col-lg-6 ms-auto order-lg-1">
                <div class="row">
                    <div class="col-sm-6 pb-3 pt-3">
                        <div class="pb-3 pt-3">
                            <h4 class="fw-bold h5 text-dark">Digitale Transformation</h4>
                            <p class="text-secondary">Mit modernen Technologien optimieren wir Ihre Finanzprozesse und steigern Effizienz sowie Wettbewerbsfähigkeit.</p>
                        </div>
                    </div>
                    <div class="col-sm-6 pb-3 pt-3">
                        <div class="pb-3 pt-3">
                            <h4 class="fw-bold h5 text-dark">Investitionslösungen</h4>
                            <p class="text-secondary">Wir identifizieren Chancen und begleiten Sie bei Investitionen, die echten Mehrwert schaffen und Ihr Portfolio stärken.</p>
                        </div>
                    </div>
                    <div class="col-sm-6 pb-3 pt-3">
                        <div class="pb-3 pt-3">
                            <h4 class="fw-bold h5 text-dark">Finanzanalyse &amp; Planung</h4>
                            <p class="text-secondary">Unsere Experten liefern präzise Analysen und Prognosen, um fundierte Entscheidungen zu treffen und Risiken zu minimieren.</p>
                        </div>
                    </div>
                    <div class="col-sm-6 pb-3 pt-3">
                        <div class="pb-3 pt-3">
                            <h4 class="fw-bold h5 text-dark">Strategische Beratung</h4>
                            <p class="text-secondary">Wir entwickeln individuelle Finanzstrategien, die Ihr Unternehmen langfristig stärken und auf Wachstumskurs bringen.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>`,
];
